import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import { CandidateDetailsState } from '../reducers/candidate-details.reducer';

// Ties into the reducers
export const getCandidateDetailsState = createSelector(fromFeature.recruitingFeature, (state: fromFeature.RecruitingRootStoreState) => state.candidateDetails);

// Selectors
export const selectChangeClinicalTracksChanged = createSelector(getCandidateDetailsState, (state: CandidateDetailsState) => state.clinicalTracksChanged);
